var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ControlsModalPlaceholder.module.scss';
import { Button } from 'src/ui/components/button/Button';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import classNames from 'classnames';
export var ControlsModalPlaceholder = function (props) {
    var i18n = props.i18n, className = props.className, onResetFilters = props.onResetFilters;
    var placeholderDescription = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.allControls.placeholder.description');
    var buttonLabel = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.allControls.placeholder.button');
    var placeholderClass = classNames(styles.controlsModalPlaceholder, className);
    return (_jsxs("div", __assign({ className: placeholderClass }, { children: [_jsx("p", { children: placeholderDescription }), _jsx(Button, { label: buttonLabel, onClick: onResetFilters })] })));
};
